module.exports = __webpack_public_path__ + "img/product.a283c585.png";